import React from "react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import ReactMarkdown from "react-markdown";
import { NextSeo } from "next-seo";
import { Disclosure } from "@headlessui/react";
import {
  ChevronRightIcon,
  MinusSmIcon,
  PlusSmIcon,
} from "@heroicons/react/solid";
import classNames from "classnames";
import { getStrapiImage } from "@/utils/strapiFunctions";
import qs from "qs";
import apiClient from "@/utils/apiClient";

export default function Medios({ mediaCenter }) {
  return (
    <>
      <NextSeo
        title="Prensa - Ambulante"
        description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
        canonical={`https://ambulante.org/prensa}`}
        openGraph={{
          url: `https://ambulante.org/prensa`,
          title: "Prensa - Ambulante",
          description:
            "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
          site_name: "Ambulante",
        }}
      />

      <section className="amb-container">
        {mediaCenter.cover ? (
          <div className="relative h-[500px] lg:h-[600px]">
            <div className="absolute inset-0">
              <img
                className="h-full w-full object-cover"
                src={getStrapiImage(mediaCenter.cover)}
                alt="Ambulante Prensa"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
        ) : null}

        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="mt-10 lg:col-span-5">
            <Text.Display as="h1" size="sm">
              Prensa
            </Text.Display>
          </div>

          <div className="mt-10 lg:col-span-7 lg:mt-0">
            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
              {mediaCenter.qa.length > 0
                ? mediaCenter?.qa.map((qa, index) => (
                    <Disclosure as="div" key={qa.id} className="pt-6">
                      {({ open }) => (
                        <>
                          <dt>
                            <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                              <span className="text-base font-semibold leading-7">
                                {qa.question}
                              </span>
                              <span className="ml-6 flex h-7 items-center">
                                {open ? (
                                  <MinusSmIcon
                                    className="h-6 w-6"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <PlusSmIcon
                                    className="h-6 w-6"
                                    aria-hidden="true"
                                  />
                                )}
                              </span>
                            </Disclosure.Button>
                          </dt>
                          <Disclosure.Panel as="dd" className="mt-2 pr-12">
                            <ReactMarkdown
                              as="div"
                              className="font-body  mt-10 prose-h2:uppercase hover:prose-a:underline  prose-li:my-2 lg:max-w-[100ch]"
                            >
                              {qa.answer}
                            </ReactMarkdown>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  ))
                : null}
            </dl>
          </div>
        </div>
      </section>
    </>
  );
}

export async function getServerSideProps() {
  const q = qs.stringify({
    populate: {
      qa: "*",
      cover: "*",
    },
  });

  const { data } = await apiClient.get(`/api/media-center?${q}`);

  return {
    props: {
      mediaCenter: data.data.attributes,
    },
  };
}

Medios.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="amb-container bg-white">
        <Nav theme="light" />
      </div>
      <div>{page}</div>
    </div>
  );
};
